import React from "react";


const EducationItem = ({ title, subtitle, date, isLast }) => {
    return (
        <div className="portfolio__data">
            {!isLast && (
                <>
                    <div>
                        <h3 className="portfolio__title">{title}</h3>
                        <span className="portfolio__subtitle">{subtitle}</span>
                        <div className="portfolio__calender">
                            <i className="uil uil-calendar-alt">{date}</i>
                        </div>
                    </div>

                    <div>
                        <span className="portfolio__rounder"></span>
                        <span className="portfolio__Educationline"></span>
                    </div>

                    <div>
                    </div>
                </>
            )}



            {isLast && (
                <>
                    <div>
                    </div>

                    <div>
                        <span className="portfolio__rounder"></span>
                        <span className="portfolio__Educationline"></span>
                    </div>
                    <div>
                        <h3 className="portfolio__title">{title}</h3>
                        <span className="portfolio__subtitle">{subtitle}</span>
                        <div className="portfolio__calender">
                            <i className="uil uil-calendar-alt">{date}</i>
                        </div>
                    </div>

                </>
            )}
        </div>
    );
};

export default EducationItem;
